import classNames from 'classnames';

import Button from '@/components/Button';

import {getAbSetting} from "@/helpers/abTesting";

import styles from './index.module.scss';
import preview from '../../../../assets/img/stauraum-bettkasten-haydn-grau.png';

export default function StartScreen ({changeScreen}) {

    return (
        <div className={classNames(styles.content, "startScreen")}>

            <img src={preview} alt="Stauraum-Bettkasten Haydn Grau"/>

            <h2>
                <em>One fits all?</em> Wir glauben nicht.
                Perfektioniere Deinen Schlaf mit der Deep-Sleep-Formel von Mozart. 😴
            </h2>

            <p>Jeder Mensch ist anders. Jeder Mensch schläft anders. Deswegen benötigt jeder Mensch ein Bett, das an seine Bedürfnisse angepasst ist.</p>
            <p>Mit unserer Deep-Sleep-Formel von Mozart bieten wir eine fundierte Matratzen- und Topper-Empfehlung für gesunden und erholsamen Schlaf, die sowohl ergonomische als auch persönliche Anforderungen berücksichtigt.</p>

            <Button className={styles.button} onClick={() => changeScreen('questions')} abClassName="Berechnung starten">Berechnung starten</Button>
            <small>Dauert ca. 60 Sekunden.</small>
        </div>
    );
}
